import { pentagonPeaks } from '../constants';

const PentagonOutline = () => (
  <g
    name="outline"
    className="pentagon-outline"
  >
    {pentagonPeaks.map((peak, index) => {
      const nextPeak = pentagonPeaks[(index + 1) % pentagonPeaks.length];
      return (
        <line
          key={`outline-line-${index}`}
          x1={`${50 + (peak[0] / 40) * 50}%`}
          x2={`${50 + (nextPeak[0] / 40) * 50}%`}
          y1={`${50 + (peak[1] / 40) * 50}%`}
          y2={`${50 + (nextPeak[1] / 40) * 50}%`}
          strokeWidth={1}
        />
      );
    })}
  </g>
);
export default PentagonOutline;
